import { TabPanel } from "devextreme-react";
import { Item } from "devextreme-react/tab-panel";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../common/Header";
import TrainingPlan from "./TrainingPlan";
import { updateLoginPopupVisible } from "../common/Redux/login";
import TrainingRecord from "./TrainingRecord";

import "./index.css";
import TrainingTracker from "./TrainingTracker";

export default function Training() {
  const userInfo = useSelector((state) => state.userInfo);

  const dispatch = useDispatch();

  const tralGridRef = useRef(null);
  const trRecGridRef = useRef(null);

  useEffect(() => {
    document.title = "Training";

    if (userInfo.employeeNo == null) {
      dispatch(updateLoginPopupVisible(true));
    }
  }, []);

  const onSelectionChanged = (e) => {
    if (e.addedItems[0].title == "plan") {
      // tralGridRef.current.instance.refresh();
      tralGridRef.current.instance.getDataSource().reload();
    } else if (e.addedItems[0].title == "My Record") {
      // trRecGridRef.current.instance.refresh();
      if (trRecGridRef.current) {
        // trRecGridRef.current.instance.getDataSource().reload();
      }
    }
  };

  return (
    <React.Fragment>
      <Header title={"TRAINING"} menuDataSource={null} />
      {userInfo.employeeNo && (
        <div style={{ margin: "40px auto", width: "95vw" }}>
          <TabPanel
            onSelectionChanged={onSelectionChanged}
            deferRendering={false}
          >
            {/* <Item title={"Plan"}> */}
            <Item title={"Attending List"}>
              <TrainingPlan tralGridRef={tralGridRef} />
            </Item>
            <Item title={"My Record"}>
              <TrainingRecord trRecGridRef={trRecGridRef} />
            </Item>
            <Item title={"Training Tracker"}>
              <TrainingTracker userInfo={userInfo} />
            </Item>
          </TabPanel>
        </div>
      )}
    </React.Fragment>
  );
}
